import React, { useEffect, useRef, useState } from "react";
import { useProfile } from "../../../features/auth/hooks/useProfile";
import { useCoach } from "../../../features/coach/contexts/CoachProvider";
import { SidebarSelect, SidebarSelectOption } from "../SidebarSelect";

const OrgSelector: React.FC = () => {
  const { organizations, isCoach } = useProfile();
  const { organizationId, setOrganizationId } = useCoach();
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    const onDocMouse = (e: MouseEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) close();
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    document.addEventListener("mousedown", onDocMouse);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocMouse);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!isCoach) return null;

  // Only if multiple orgs
  if (!organizations || organizations.length === 0) return null;

  const activeOrg = organizations.find((o) => Number(o.id) === organizationId);

  return (
    <div ref={rootRef} className="px-4">
      <SidebarSelect
        label="Organization"
        valueLabel={activeOrg?.name ?? ""}
        placeholder="Select organization"
        isOpen={open}
        onToggle={() => setOpen((v) => !v)}
      >
        {organizations.map((org) => (
          <SidebarSelectOption
            key={org.id}
            selected={Number(org.id) === organizationId}
            onSelect={() => {
              setOrganizationId(String(org.id));
              setOpen(false);
            }}
          >
            {org.name}
          </SidebarSelectOption>
        ))}
      </SidebarSelect>
    </div>
  );
};

export default OrgSelector;
